import React, { useEffect, useRef } from 'react';

const AboutPage = () => {
  const sectionsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.2 }
    );

    sectionsRef.current.forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="static-page about-page">
      <h1><u>About Us:</u></h1>
      
      <section ref={(el) => (sectionsRef.current[0] = el)} className="scroll-section">
        <h2>Who We Are</h2>
        <p>
          <img src='/assets/icons/right.svg' style={{ width: '17px', height: '15px', filter: 'brightness(0) saturate(100%) invert(58%) sepia(89%) saturate(2270%) hue-rotate(176deg) brightness(99%) contrast(93%)', marginBottom: '0px' }} /> 
           At iwantcheats , we offer high quality game Cheats. We ensure the highest quality through in-depth development, testing and maintenance. 
        </p><br></br><p>
          <img src='/assets/icons/right.svg' style={{ width: '17px', height: '15px', filter: 'brightness(0) saturate(100%) invert(58%) sepia(89%) saturate(2270%) hue-rotate(176deg) brightness(99%) contrast(93%)', marginBottom: '0px' }} />
            Seller of the best private cheats from around the world for your favorite games! 
        </p><br></br><p>
          <img src='/assets/icons/right.svg' style={{ width: '17px', height: '15px', filter: 'brightness(0) saturate(100%) invert(58%) sepia(89%) saturate(2270%) hue-rotate(176deg) brightness(99%) contrast(93%)', marginBottom: '0px' }} />
            We are proud to provide the industry's leading game cheats. 
        </p><br></br><p>
        <img src='/assets/icons/right.svg' style={{ width: '17px', height: '15px', filter: 'brightness(0) saturate(100%) invert(58%) sepia(89%) saturate(2270%) hue-rotate(176deg) brightness(99%) contrast(93%)', marginBottom: '0px' }} />
          Getting started is straight-forward and when you need assistance, our support is here to assist you..
        </p>
      </section>

      <section ref={(el) => (sectionsRef.current[1] = el)} className="scroll-section">
        <h2>Why Choose Us:</h2>
        <ul>
          <li>✓ Instant delivery</li>
          <li>✓ Secure cryptocurrency payments</li>
          <li>✓ 24/7 customer support</li>
          <li>✓ Competitive prices</li>
          <li>✓ Wide selection of Games</li>
        </ul>
      </section>

      <section ref={(el) => (sectionsRef.current[2] = el)} className="scroll-section">
        <h2>Our Mission</h2>
        <p>
          To make cheats available at fingertips, simple, secure, and accessible to everyone through 
          innovative FEATUREs and exceptional customer service.
        </p>
      </section>
    </div>
  );
};

export default AboutPage;
